import { render, staticRenderFns } from "./btn-trigger.vue?vue&type=template&id=56223932&scoped=true&"
import script from "./btn-trigger.vue?vue&type=script&lang=js&"
export * from "./btn-trigger.vue?vue&type=script&lang=js&"
import style0 from "./btn-trigger.vue?vue&type=style&index=0&id=56223932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56223932",
  null
  
)

export default component.exports